import * as Yup from "yup";
import { formatDate,convertToISO } from "../../utilities";

export const formSections = [
  {
    title: "Personal Details",
    fields: [
      {
        label: "Full Name",
        name: "firstName",
        type: "text",
        placeholder: "First Name",
        required: true,
      },
     
      {
        label: "Date of Birth",
        name: "dateOfBirth",
        type: "date",
        placeholder: "Date of Birth",
        required: true,
      },

      {
        label: "Contact No",
        name: "contactNumber",
        type: "text",
        placeholder: "Enter Contact No",
        required: true,
      },
      {
        label: "Searching For",
        name: "searchingFor",
        type: "select",
        placeholder: "Select Searching for",
        key: "mst-profiletype",
        required: true,
      },

      {
        label: "Birth Location",
        name: "birthLocation",
        type: "select",
        placeholder: " Select Birth Location",
        key: "mst-location",
        required: true,
      },
      {
        label: "Resident Location",
        name: "residentLocation",
        type: "select",
        placeholder: "Resident Location",
        key: "mst-location",
        required: true,
      },
      {
        label: "Height",
        name: "height",
        type: "select",
        placeholder: "Enter Height",
        key: "mst-heights",
        required: true,
      },

      {
        label: "Weight in (Kg's)",
        name: "weight",
        type: "number",
        placeholder: "Enter Weight",
        required: true,
      },
      {
        label: "Body Type",
        name: "bodyType",
        type: "select",
        placeholder: "Select Body Type",
        key: "mst-body-type",
        required: false,
      },

      {
        label: "Skin Tone",
        name: "skinTone",
        type: "select",
        placeholder: "Enter Skin Tone",
        key: "mst-skintone",
        required: true,
      },
    ],
  },
  {
  title: "Aadhaar Details",
  fields: [
    {
      label: "Full Name",
      name: "_aadharUserDetails.full_name",
      type: "text",
      placeholder: "Enter Aadhaar Full Name",
      required: true,
    },
    {
      label: "Last 4 digits",
      name: "_last4Digits",
      type: "text",
      placeholder: "Enter Aadhaar Last 4 Digits",
      required: true,
    },
    {
      label: "Date of Birth",
      name: "_aadharUserDetails.dob",
      type: "date",
      placeholder: "Date of Birth",
      required: true,
    },
    {
      label: "Gender",
      name: "_aadharUserDetails.gender",
      type: "select",
      placeholder: "Select Gender",
      options: [
        { label: "Male", value: "MALE" },
        { label: "Female", value: "FEMALE" },
        { label: "Other", value: "O" }
      ],
      required: true,
    },
    {
      label: "Care Of (C/O)",
      name: "_aadharUserDetails.care_of",
      type: "text",
      placeholder: "Enter Guardian / Father Name",
      required: true,
    },
    // Address Fields
    {
      label: "House",
      name: "_aadharUserDetails.address.house",
      type: "text",
      placeholder: "Enter House Number",
      required: true,
    },
    {
      label: "Street",
      name: "_aadharUserDetails.address.street",
      type: "text",
      placeholder: "Enter Street",
      required: true,
    },
    {
      label: "Landmark",
      name: "_aadharUserDetails.address.landmark",
      type: "text",
      placeholder: "Enter Landmark (optional)",
      required: false,
    },
    {
      label: "Village/Town/City",
      name: "_aadharUserDetails.address.vtc",
      type: "text",
      placeholder: "Enter VTC",
      required: true,
    },
    {
      label: "Location",
      name: "_aadharUserDetails.address.loc",
      type: "text",
      placeholder: "Enter Location",
      required: true,
    },
    {
      label: "Sub-District",
      name: "_aadharUserDetails.address.subdist",
      type: "text",
      placeholder: "Enter Sub District",
      required: true,
    },
    {
      label: "District",
      name: "_aadharUserDetails.address.dist",
      type: "text",
      placeholder: "Enter District",
      required: true,
    },
    {
      label: "State",
      name: "_aadharUserDetails.address.state",
      type: "text",
      placeholder: "Enter State",
      required: true,
    },
    {
      label: "Country",
      name: "_aadharUserDetails.address.country",
      type: "text",
      placeholder: "Enter Country",
      required: true,
    },
    {
      label: "Post Office",
      name: "_aadharUserDetails.address.po",
      type: "text",
      placeholder: "Enter Post Office",
      required: true,
    },
    {
      label: "PIN Code",
      name: "_aadharUserDetails.address.zip",
      type: "text",
      placeholder: "Enter 6-digit PIN Code",
      required: true,
    }
  ]
},


  {
    title: "Community Details",
    fields: [
      {
        label: "Religion",
        name: "religion",
        type: "select",
        placeholder: "Select Religion",
        key: "mst-religion",
        required: true,
      },
      {
        label: "Caste",
        name: "caste",
        type: "select",
        placeholder: "Select Caste",
        key: "mst-caste",
        filter: true,
        required: false,
      },
      {
        label: "Sub Caste",
        name: "subCaste",
        type: "text",
        placeholder: "Enter Sub Caste Name",
        required: false,
      },
      {
        label: "Religious Belief",
        name: "religiousBelief",
        type: "select",
        placeholder: "Select Religious Belief",
        key: "mst-regiousbelief",
        required: true,
      },
      {
        label: "Mother Tongue",
        name: "motherTongue",
        type: "select",
        placeholder: "Select Mother Tongue",
        key: "mst-language",
        required: true,
      },
    ],
  },
  
  {
    title: "Education & Professional Details",
    fields: [
      {
        label: "Qualification",
        name: "qualification",
        type: "select",
        placeholder: "Select Qualification",
        key: "mst-qualification",
        required: true,
      },
      {
        label: "Field Of Study",
        name: "fieldOfStudy",
        type: "select",
        placeholder: "Select Field Of Study",
        key: "mst-field-of-study",
        required: true,
      },
      {
        label: "Profession Sector",
        name: "professionSector",
        type: "select",
        placeholder: "Select Organisation",
        key: "mst-profession-sector",
        required: true,
      },

      {
        label: "Organisation Name",
        name: "organizationName",
        type: "text",
        placeholder: "Select Organisation Name",
        key: "organisations",
        required: true,
      },
      {
        label: "Designation",
        name: "professionalDesignation",
        type: "select",
        placeholder: "Select Designation",
        key: "mst-designation",
        required: true,
      },
      {
        label: "Earning Per Annum",
        name: "annualIncome",
        type: "select",
        placeholder: "Select Earning Per Annum",
        key: "mst-annual-income",
        required: true,
      },
    ],
  },

  {
    title: "Astrology Details",
    fields: [
      {
        label: "Star",
        name: "star",
        type: "select",
        placeholder: "Select Star",
        key: "mst-astrology-star",
        required: false,
      },

      {
        label: "Nakshatra",
        name: "nakshatra",
        type: "select",
        placeholder: "Select Nakshatra",
        key: "mst-nakshatra",
        required: false,
      },
      {
        label: "Raashi",
        name: "raashi",
        type: "select",
        placeholder: "Select Raashi",
        key: "mst-raashi",
        required: false,
      },
      {
        label: "Gothram",
        name: "gothram",
        type: "select",
        placeholder: "Select Gothram",
        key: "mst-gotram",
        required: false,
      },
      {
        label: "Dosha",
        name: "dosha",
        type: "select",
        placeholder: "Select Dosha",
        key: "mst-dosha",
        required: false,
      },
    ],
  },
  {
    title: "Family & Other Details",
    fields: [
      {
        label: "Family Name",
        name: "familyName",
        type: "text",
        placeholder: "Enter Family Name",
        required: false,
      },
      {
        label: "Family Type",
        name: "familyType",
        type: "select",
        placeholder: "Select Family Type",
        key: "mst-familytype",
        required: true,
      },
      {
        label: "Diet Type",
        name: "dietType",
        type: "select",
        placeholder: "Select Diet Type",
        key: "mst-diettype",
        required: true,
      },
      {
        label: "Mother Details",
        name: "familyDetails.motherDetails",
        type: "select",
        placeholder: "Select Mother Details",
        key: "mst-mother-details",
        required: true,
      },
      {
        label: "Father Details",
        name: "familyDetails.fatherDetails",
        type: "select",
        placeholder: "Select Father Details",
        key: "mst-father-details",
        required: true,
      },
      {
        label: "No Of Brothers",
        name: "familyDetails.no_of_brothers",
        type: "number",
        placeholder: "Enter No Of Brothers",
        required: false,
      },
      {
        label: "No Of Sisters",
        name: "familyDetails.no_of_sisters",
        type: "number",
        placeholder: "Enter No Of Sisters",
        required: false,
      },
    ],
  },
];

export const intialValuesBgProfile = {
  firstName: "",
  lastName: "",
  dateOfBirth: "",
  height: null,
  weight: null,
  isDisabilityExists: "false",
  disabilityDetails: "",
  bodyType: null,
  skinTone: null,
  profileImage: "",
  imageGallery: [null, null, null, null, null],
  religion: null,
  caste: null,
  subCaste: "",
  religiousBelief: null,
  motherTongue: null,
  qualification: null,
  fieldOfStudy: null,
  gender: null,
  professionalDesignation: null,
  annualIncome: null,
  familyType: null,
  dietType: null,
  familyName: "",
  star: null,
  nakshatra: null,
  raashi: null,
  gothram: null,
  dosha: null,
  birthLocation: null,
  residentLocation: null,
  professionSector: null,
  searchingFor: null,
  contactNumber: "",
  ownedBy: null,
  ownerRelationship: null,
  educationDetails: "",
  educationalInstitute: "",
  selectedHobbies: [],
  organizationName: "",
  accountStatus: "",
  preferences: {
    height: [],
    skinTone: [],
    religion: [],
    caste: [],
    religiousBelief: [],
    motherTongue: [],
    familyType: [],
    dietType: [],
    professionSector: [],
    annualIncome: [],
    qualification: [],
    star: [],
    gothram: [],
    // Scalar / scope prefs — mirror what the seeker app collects so admin edits
    // the same shape (see bg_profile.preferences + onboardBgProfileController).
    minAge: "",
    maxAge: "",
    minHeightCm: "",
    maxHeightCm: "",
    locationScope: null,
    targetStates: [],
  },
  familyDetails: {
    fatherDetails: null,
    motherDetails: null,
    no_of_brothers: 0,
    brothersDetails: [],
    no_of_sisters: 0,
    sistersDetails: [],
  },

  _aadharUserDetails: {
      full_name: "",
      dob: "",
      gender: "",
      care_of: "",
      address: {
        country: "",
        dist: "",
        state: "",
        po: "",
        loc: "",
        vtc: "",
        subdist: "",
        street: "",
        house: "",
        landmark: "",
        zip: "",
      },
    },
    _last4Digits:""




};

// yup validation schema
const optionalObjectSchema = Yup.object({
  value: Yup.string().optional(),
  label: Yup.string().optional(),
});
const optionalArraySchema = Yup.array().of(optionalObjectSchema).optional();
const lettersAndSpacesRegex = /^[\w\s\-\/#]+$/


const notOnlySpaces = (fieldName) =>
  Yup.string()
    .trim()
    .test("not-only-spaces", `${fieldName} cannot be empty or only spaces`, (value) => {
      return value && value.trim().length > 0;
    });


export const yupValidationBgProfile = Yup.object({
  ownedBy: optionalObjectSchema.required("Added By is required"),
  ownerRelationship: optionalObjectSchema.optional().nullable(),
  firstName: Yup.string()
    .required("First name is required")
    .min(3, "Minimum 3 characters needed")
    .max(25, "Maximum 25 characters allowed")
    .test(
      "no-whitespace",
      "First name cannot be empty or contain only spaces",
      (value) => value && value.trim().length > 0
    ),
  lastName: Yup.string()
    .max(20, "Maximum 20 characters allowed")
    .test(
      "no-whitespace",
      "Last name cannot be empty or contain only spaces",
      (value) => value && value.trim().length > 0
    ).optional()
    .nullable(),

    lastName: Yup.string()
  .max(20, "Maximum 20 characters allowed")
  .test(
    "no-whitespace",
    "Last name cannot be empty or contain only spaces",
    (value) => !value || value.trim().length > 0
  )
  .nullable()
  .optional(),

    

  organizationName: Yup.string()
    .required("Organisation Name is required")
    .min(2, "Minimum 2 characters needed")
    .max(50, "Maximum 50 characters allowed")
    .test(
      "no-whitespace",
      "Organization Name cannot be empty or contain only spaces",
      (value) => value && value.trim().length > 0
    ),

  isDisabilityExists: Yup.boolean().required(
    "Disability existence is required"
  ),
  disabilityDetails: Yup.string().when("isDisabilityExists", {
    is: (value) => value === true,
    then: (schema) =>
      schema
        .required("Disability/Medical Condition details are required")
        .min(10, "Minimum 10 Characters Required")
        .max(100, "Maximum 100 Characters Allowed")
        .test(
          "no-whitespace",
          "Details cannot be empty or contain only spaces",
          (value) => value && value.trim().length > 0
        ),
    otherwise: (schema) => schema.optional().nullable(),
  }),

  contactNumber: Yup.string()
    .matches(
      /^[6-9][0-9]{9}$/,
      "Contact number must start with 9, 8, 7, or 6 and be exactly 10 digits long"
    )
    .required("Contact No is Required"),

  dateOfBirth: Yup.date()
    .required("Date of Birth is required")
    .test("minimum-age", "Minimum age requirement not met", function (value) {
      const { gender } = this.parent;
      const today = new Date();
      const birthDate = new Date(value);
      const age = today.getFullYear() - birthDate.getFullYear();
      const monthDifference = today.getMonth() - birthDate.getMonth();
      const dayDifference = today.getDate() - birthDate.getDate();

      if (birthDate.getFullYear() < 1950) {
        return this.createError({
          message: "Year of birth cannot be before 1950",
        });
      }

      // const isOldEnough = age > (gender?.value === "Female" ? 18 : 21) || (age === (gender?.value === "Female" ? 18 : 21) &&(monthDifference > 0 || (monthDifference === 0 && dayDifference >= 0)));
      const isOldEnough = age > 18 || (age === 18 && (monthDifference > 0 || (monthDifference === 0 && dayDifference >= 0)));
      
      return isOldEnough;
    }),
  profileImage: Yup.string().required("Profile Image is required"),
  imageGallery: Yup.array()
    .of(Yup.string().nullable())
    .min(1, "Atleast one image is needed")
    .max(6, "You can upload up to 6 images"),
  birthLocation: optionalObjectSchema.required("Birth Location is required"),
  gender: optionalObjectSchema.nullable(),
  searchingFor: optionalObjectSchema.required("Profile Type is required"),
  residentLocation: optionalObjectSchema.required(
    "Resident Location is required"
  ),
  height: optionalObjectSchema.required("Height is required"),
  weight: Yup.number()
    .min(1, "Weight should be greater than zero")
    .max(200, "Max weight cannot be more than 200Kgs")
    .required("Weight is required"),
  bodyType: optionalObjectSchema.optional().nullable(),
  skinTone: optionalObjectSchema.required("Skin Tone is required"),
  religion: optionalObjectSchema.required("Religion is required"),
  caste: optionalObjectSchema
    .when("religion", {
      is: (religion) => !!religion,
      then: (schema) => schema.optional().nullable(),
      otherwise: (schema) => schema.optional().nullable(),
    })
    .nullable(),

  subCaste: Yup.string()
    .when("caste", {
      is: (caste) => !!caste?.value,
      then: (schema) => schema.optional(),
      otherwise: (schema) => schema.optional(),
    })
    .nullable(),

  professionalDesignation: optionalObjectSchema.required(
    "Designation is required"
  ),
  professionSector: optionalObjectSchema.required("Sector is required"),
  qualification: optionalObjectSchema.required("Qualification is required"),
  fieldOfStudy: optionalObjectSchema.required("Field of study required"),
  annualIncome: optionalObjectSchema.required("Earning per annum is required"),
  familyName: Yup.string(),
  familyType: optionalObjectSchema.required("Family Type is required"),
  dietType: optionalObjectSchema.required("Diet Type is required"),

  star: optionalObjectSchema.optional().nullable(),
  nakshatra: optionalObjectSchema.optional().nullable(),
  raashi: optionalObjectSchema.optional().nullable(),
  gothram: optionalObjectSchema.optional().nullable(),
  dosha: optionalObjectSchema.optional().nullable(),

  motherTongue: optionalObjectSchema.required("Mother Tongue is required"),
  religiousBelief: optionalObjectSchema.required(
    "Religious Belief is required"
  ),
  selectedHobbies: Yup.array().optional(),
  preferences: Yup.object({
    height: optionalArraySchema,
    skinTone: optionalArraySchema,
    caste: optionalArraySchema,
    motherTongue: optionalArraySchema,
    religion: optionalArraySchema,
    familyType: optionalArraySchema,
    dietType: optionalArraySchema,
    professionSector: optionalArraySchema,
    annualIncome: optionalArraySchema,
    qualification: optionalArraySchema,
    star: optionalArraySchema,
    gothram: optionalArraySchema,
    // Scalar / scope prefs — all optional. Empty string → null so a blank field
    // never blocks the save; ranges mirror the backend guards.
    minAge: Yup.number()
      .transform((v, o) => (o === "" || o === null ? null : v))
      .nullable()
      .min(18, "Min age is 18")
      .max(75, "Max age is 75")
      .notRequired(),
    maxAge: Yup.number()
      .transform((v, o) => (o === "" || o === null ? null : v))
      .nullable()
      .min(18, "Min age is 18")
      .max(75, "Max age is 75")
      .notRequired()
      .test("age-order", "Max age must be ≥ min age", function (value) {
        const { minAge } = this.parent;
        if (value == null || minAge == null || minAge === "") return true;
        return Number(value) >= Number(minAge);
      }),
    minHeightCm: Yup.number()
      .transform((v, o) => (o === "" || o === null ? null : v))
      .nullable()
      .min(120, "Min height is 120 cm")
      .max(215, "Max height is 215 cm")
      .notRequired(),
    maxHeightCm: Yup.number()
      .transform((v, o) => (o === "" || o === null ? null : v))
      .nullable()
      .min(120, "Min height is 120 cm")
      .max(215, "Max height is 215 cm")
      .notRequired()
      .test("height-order", "Max height must be ≥ min height", function (value) {
        const { minHeightCm } = this.parent;
        if (value == null || minHeightCm == null || minHeightCm === "") return true;
        return Number(value) >= Number(minHeightCm);
      }),
    locationScope: Yup.string()
      .nullable()
      .oneOf(
        ["specific_states", "all_india", "nri_specific", "nri_all", null],
        "Invalid location scope"
      )
      .notRequired(),
    targetStates: Yup.array().of(Yup.string()).optional(),
  }).optional(),
  accountStatus: optionalObjectSchema.required("Account status is required"),

  familyDetails: Yup.object({
    fatherDetails: optionalObjectSchema.required("Father details are required"),
    motherDetails: optionalObjectSchema.required("Mother details are required"),
    no_of_brothers: Yup.number()
      .default(0)
      .min(0, "Number of brothers cannot be negative")
      .max(10, "You can only add up to 10 brothers"),
    brothersDetails: Yup.array()
      .of(
        Yup.object({
          marital_status: Yup.boolean().required("Marital status is required"),
          occupation: optionalObjectSchema.required("Occupation is required"),
        })
      )
      .test(
        "brothersDetails-length",
        "Please provide details for all brothers",
        function (value) {
          return value?.length === this.parent.no_of_brothers;
        }
      ),
    no_of_sisters: Yup.number()
      .default(0)
      .min(0, "Number of sisters cannot be negative")
      .max(50, "You can only add up to 10 sisters"),
    sistersDetails: Yup.array()
      .of(
        Yup.object({
          isMarried: Yup.boolean().required("Marriage status is required"),
          occupation: optionalObjectSchema.required("Occupation is required"),
        })
      )
      .test(
        "sistersDetails-length",
        "Please provide details for all sisters",
        function (value) {
          return value?.length === this.parent.no_of_sisters;
        }
      ),
  }).required(),


   // Aadhaar is deprecated/bypassed and not collected from admin — keep optional so saves aren't blocked.
   _last4Digits: Yup.string().nullable().notRequired(),
  
  
   // Aadhaar deprecated/bypassed — object is optional and not validated; no real Aadhaar is collected or stored.
   _aadharUserDetails : Yup.object().nullable().notRequired(),




});

export const mapProfileDetailsToSchema = (profileDetails) => {
  console.log(profileDetails,"these are profileDetails")
  const {
    ownedBy,
    firstName,
    lastName,
    organizationName,
    contactNumber,
    dateOfBirth,
    profileImage,
    imageGallery,
    birthLocation,
    gender,
    searchingFor,
    residentLocation,
    height,
    skinTone,
    religion,
    caste,
    subCaste,
    professionalDesignation,
    professionSector,
    qualification,
    annualIncome,
    familyName,
    familyType,
    dietType,
    star,
    gothram,
    motherTongue,
    religiousBelief,
    selectedHobbies,
    preferences,
    accountStatus,
    familyDetails,
    fieldOfStudy,
    nakshatra,
    raashi,
    ownerRelationship,
    dosha,
    weight,
    bodyType,
    isDisabilityExists,
    disabilityDetails,
    _aadharReferenceId,
  } = profileDetails;

  // Profiles created via the new onboarding flow can be missing many of the
  // legacy "complete profile" fields. Every access below is null-safe so the
  // edit form loads regardless of which fields are populated. `opt()` returns
  // a react-select { value, label } only when the ref exists, else null.
  // `list()` maps an array of refs, defaulting to [] when absent.
  const opt = (obj, labelKey) =>
    obj && obj._id ? { value: obj._id, label: obj[labelKey] } : null;
  const list = (arr, labelKey) =>
    Array.isArray(arr)
      ? arr
          .filter((x) => x && x._id)
          .map((x) => ({ value: x._id, label: x[labelKey] }))
      : [];

  const fam = familyDetails || {};
  const prefs = preferences || {};

  return {
    _aadharUserDetails:{
      ..._aadharReferenceId?._aadharUserDetails,
      aadharId:_aadharReferenceId?._id,
      dob:_aadharReferenceId?._aadharUserDetails?.dob && convertToISO(_aadharReferenceId._aadharUserDetails.dob)

    }||{},
   _last4Digits:_aadharReferenceId?._last4Digits||"",
    isDisabilityExists: isDisabilityExists ? "true" : "false",
    disabilityDetails,
    weight,
    bodyType: opt(bodyType, "bodytype"),

    ownerRelationship: opt(ownerRelationship, "matchFor"),

    raashi: opt(raashi, "raashi"),
    dosha: opt(dosha, "dosha"),

    nakshatra: opt(nakshatra, "nakshatra"),
    star: opt(star, "zodiacSign"),

    gothram: opt(gothram, "gotram"),

    fieldOfStudy: opt(fieldOfStudy, "profession"),
    familyDetails: {
      ...fam,
      motherDetails: {
        value: fam?.motherDetails?._id,
        label: fam?.motherDetails?.motherDetails,
      },
      fatherDetails: {
        value: fam?.fatherDetails?._id,
        label: fam?.fatherDetails?.fatherDetails,
      },
      brothersDetails: Array.isArray(fam.brothersDetails)
        ? fam.brothersDetails.map((each) => ({
            marital_status: each.marital_status === true ? "true" : "false",
            occupation: {
              label: each?.occupation?.designation,
              value: each?.occupation?._id,
            },
          }))
        : [],
      sistersDetails: Array.isArray(fam.sistersDetails)
        ? fam.sistersDetails.map((each) => ({
            isMarried: each.isMarried === true ? "true" : "false",
            occupation: {
              label: each?.occupation?.designation,
              value: each?.occupation?._id,
            },
          }))
        : [],
    },
    ownedBy: ownedBy
      ? { value: ownedBy._id, label: ownedBy._phoneNumber }
      : null,
    firstName,
    lastName,
    organizationName,
    contactNumber: contactNumber !== null ? contactNumber?.toString() : "",
    dateOfBirth: formatDate(dateOfBirth),
    profileImage,
    imageGallery,
    birthLocation: opt(birthLocation, "city"),
    gender: { value: gender, label: gender },
    searchingFor: opt(searchingFor, "gender"),
    residentLocation: opt(residentLocation, "city"),
    height: opt(height, "heights"),
    skinTone: opt(skinTone, "skintype"),
    religion: opt(religion, "religion"),
    caste: opt(caste, "caste"),
    subCaste,
    professionalDesignation: opt(professionalDesignation, "designation"),
    professionSector: opt(professionSector, "professionSector"),
    qualification: opt(qualification, "qualification"),
    annualIncome: opt(annualIncome, "annual Income In(₹)"),
    familyName,
    familyType: opt(familyType, "familyType"),
    dietType: opt(dietType, "dietType"),
    motherTongue: opt(motherTongue, "language"),
    religiousBelief: opt(religiousBelief, "belief"),
    selectedHobbies: selectedHobbies || [],

    accountStatus: { label: accountStatus, value: accountStatus },
    preferences: {
      height: list(prefs.height, "heights"),
      skinTone: list(prefs.skinTone, "skintype"),
      caste: list(prefs.caste, "caste"),
      motherTongue: list(prefs.motherTongue, "language"),
      religion: list(prefs.religion, "religion"),
      familyType: list(prefs.familyType, "familyType"),
      dietType: list(prefs.dietType, "dietType"),
      professionSector: list(prefs.professionSector, "professionSector"),
      annualIncome: list(prefs.annualIncome, "annual Income In(₹)"),
      qualification: list(prefs.qualification, "qualification"),
      star: list(prefs.star, "zodiacSign"),
      gothram: list(prefs.gothram, "gotram"),
      religiousBelief: list(prefs.religiousBelief, "belief"),
      // Scalar / scope prefs — restore so an admin sees what the seeker set in
      // the app. null/undefined → "" for the number inputs, [] for states.
      minAge: prefs.minAge ?? "",
      maxAge: prefs.maxAge ?? "",
      minHeightCm: prefs.minHeightCm ?? "",
      maxHeightCm: prefs.maxHeightCm ?? "",
      locationScope: prefs.locationScope ?? null,
      targetStates: Array.isArray(prefs.targetStates) ? prefs.targetStates : [],
    },
  };
};
